import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Instagram, Twitter, Youtube } from "lucide-react";
import EarlyAccessModal from "@/components/EarlyAccessModal";
import VituraAnimatedLogo from "@/components/VituraAnimatedLogo";
import { PrivacyLink } from "@/components/privacy/PrivacyLink";
import { MobileTermsLink } from "@/components/privacy/MobileTermsLink";
import { CookieSettingsLink } from "@/components/privacy/CookieSettingsLink";

export default function Footer() {
  const [waitlistOpen, setWaitlistOpen] = useState(false);
  return (
    <footer className="mt-24 bg-[#0f0f10] text-[#faf9f5]" data-testid="site-footer">
      <div className="max-w-site mx-auto px-6 md:px-10 pt-16 pb-8">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="label !text-[#faf9f5]/70 mb-4">The Vitura Journal</div>
            <h3 className="font-display text-3xl md:text-4xl leading-none mb-6">Letters from the lab.<br /><span className="editorial normal-case">No noise. Just signal.</span></h3>
            <button
              type="button"
              onClick={() => setWaitlistOpen(true)}
              className="inline-flex items-center gap-3 label !text-[#faf9f5] hover:opacity-70 border-b border-[#faf9f5]/30 pb-3 w-full max-w-md text-left"
              data-testid="footer-waitlist-cta"
            >
              <span className="flex-1">Join the early access list</span>
              <span>→</span>
            </button>
          </div>

          <div className="md:col-span-7 grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">
            <div>
              <div className="label !text-[#faf9f5]/60 mb-4">Shop</div>
              <ul className="space-y-2.5 text-sm">
                <li><Link to="/preview/shop" className="hover:opacity-70">All Flavors</Link></li>
                <li><Link to="/preview/product/cucumber-melon" className="hover:opacity-70">Cucumber Melon</Link></li>
                <li><Link to="/preview/product/white-apple-peach" className="hover:opacity-70">White Peach Apple</Link></li>
                <li><Link to="/preview/shop" className="hover:opacity-70">Subscribe & Save</Link></li>
              </ul>
            </div>
            <div>
              <div className="label !text-[#faf9f5]/60 mb-4">Discover</div>
              <ul className="space-y-2.5 text-sm">
                <li><Link to="/journal" className="hover:opacity-70">Journal</Link></li>
                <li><Link to="/journal/clinical-doses-matter" className="hover:opacity-70">The Science</Link></li>
                <li><Link to="/journal/why-paraxanthine" className="hover:opacity-70">Paraxanthine</Link></li>
              </ul>
            </div>
            <div>
              <div className="label !text-[#faf9f5]/60 mb-4">Support</div>
              <ul className="space-y-2.5 text-sm">
                <li><Link to="/preview/account" className="hover:opacity-70">Account</Link></li>
                <li><a href="mailto:hello@takevitura.com" className="hover:opacity-70">hello@takevitura.com</a></li>
                <li><a href="#faq" className="hover:opacity-70">FAQ</a></li>
                <li><Link to="/preview/shop" className="hover:opacity-70">Shipping & Returns</Link></li>
                <li><PrivacyLink testId="site-footer-privacy-link" /></li>
                <li><MobileTermsLink testId="site-footer-mobile-terms-link" /></li>
                <li><CookieSettingsLink testId="site-footer-cookie-settings-link" /></li>
              </ul>
            </div>
            <div>
              <div className="label !text-[#faf9f5]/60 mb-4">Follow</div>
              <ul className="space-y-2.5 text-sm">
                <li><a href="https://instagram.com/takevitura" target="_blank" rel="noopener noreferrer" className="hover:opacity-70 inline-flex items-center gap-2" data-testid="footer-ig"><Instagram size={14} /> @takevitura</a></li>
                <li><a href="https://x.com/takevitura" target="_blank" rel="noopener noreferrer" className="hover:opacity-70 inline-flex items-center gap-2" data-testid="footer-x"><Twitter size={14} /> @takevitura</a></li>
                <li><a href="https://youtube.com/@takevitura?si=_jxEP3uLqmncA142" target="_blank" rel="noopener noreferrer" className="hover:opacity-70 inline-flex items-center gap-2" data-testid="footer-youtube"><Youtube size={14} /> @takevitura</a></li>
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-16 pt-6 border-t border-[#faf9f5]/15 flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
          <VituraAnimatedLogo color="#faf9f5" width={120} />
          <div className="label !text-[#faf9f5]/50">© {new Date().getFullYear()} VITURA · Engineered in the USA · 3rd-party tested by EUROFINS</div>
        </div>
      </div>

      <div className="relative overflow-hidden">
        <div className="font-display uppercase whitespace-nowrap leading-none text-[22vw] tracking-tighter text-[#faf9f5]/5 select-none pointer-events-none text-center pb-4">
          VITURA
        </div>
      </div>

      <EarlyAccessModal open={waitlistOpen} onOpenChange={setWaitlistOpen} source="footer" />
    </footer>
  );
}
